import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { NoDataSubtitleDirective, NoDataTitleDirective } from './no-data.directives';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[woNoData]',
  templateUrl: './no-data.component.html',
  styleUrls: [ './no-data.component.scss' ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [ NgTemplateOutlet ],
})
export class NoDataComponent {
  @ContentChild(NoDataTitleDirective, { static: false }) viewTitle?: NoDataTitleDirective;
  @ContentChild(NoDataSubtitleDirective, { static: false }) viewSubtitle?: NoDataSubtitleDirective;

  @Input() public title?: TemplateRef<unknown>;
  @Input() public subtitle?: TemplateRef<unknown>;
  @Input() public height = '435px';
}
